// Metric formatting utilities following Single Responsibility Principle
// Pure functions for easy testing and reusability

/**
 * Formats TVL values to display format
 * @param {number} value - Raw TVL value
 * @returns {string} Formatted TVL string
 */
export const formatTVL = (value) => {
  if (!value || isNaN(value)) return '---';
  
  if (value >= 1000000) {
    return `+ $${(value / 1000000).toFixed(1)}M`;
  } else if (value >= 1000) {
    return `+ $${(value / 1000).toFixed(1)}K`;
  }
  
  return `+ $${value.toLocaleString()}`;
};

/**
 * Formats account/user counts to display format
 * @param {number} value - Raw account count
 * @returns {string} Formatted account string
 */
export const formatAccounts = (value) => {
  if (!value || isNaN(value)) return '---';
  
  if (value >= 1000) {
    return `+ ${(value / 1000).toFixed(1)}K users`;
  }
  
  return `+ ${value.toLocaleString()} users`;
};

/**
 * Generic metric formatter - Liskov Substitution Principle
 * @param {string} metricType - Type of metric to format
 * @param {number} value - Raw value
 * @returns {string} Formatted metric string
 */
export const formatMetric = (metricType, value) => {
  switch (metricType) {
    case 'TVL':
      return formatTVL(value);
    case 'accounts':
      return formatAccounts(value);
    default:
      return value?.toLocaleString() || '---';
  }
};
